// Single source of truth for walkthrough flags: their keys and the value
// used both when initializing them for a new user and when reading them
// from Supabase `user_metadata.walkthrough` (fallback when a key is absent).
export const WALKTHROUGH_DEFAULTS = {
  onboarding_dashboard: false,
  onboarding_payroll_dashboard: false,
  onboarding_new_payroll: false,
  onboarding_finish_payroll: false,
  onboarding_payroll_workers: false,
  onboarding_payroll_worker_one: false,
  onboarding_payroll_worker_active: false,
  onboarding_job_postings: false,
  onboarding_pipeline: false,
  onboarding_pipeline_v2: true,
  onboarding_first_Payment_Method: false,
  onboarding_assistant: false,
  onboarding_matches_table: false,
  onboarding_team_collaboration: false,
  onboarding_invite_member: true,
  onboarding_contract_details: false,
  onboarding_plans_and_billing: true,
  onboarding_candidate: false,
  onboarding_candidate_detail: false,
  onboarding_candidate_discarted: true,
  onboarding_candidate_hire: false,
} as const satisfies Record<string, boolean>;

export type WalkthroughKey = keyof typeof WALKTHROUGH_DEFAULTS;

export type WalkthroughFlags = { [K in WalkthroughKey]: boolean };

const WALKTHROUGH_KEYS = Object.keys(WALKTHROUGH_DEFAULTS) as WalkthroughKey[];

// Init payload for `updateWalkthrough` (creates row if missing).
export const walkthroughInitFlags: ReadonlyArray<{
  key: WalkthroughKey;
  completed: boolean;
}> = WALKTHROUGH_KEYS.map((key) => ({ key, completed: WALKTHROUGH_DEFAULTS[key] }));

// Normalize a raw metadata.walkthrough object into a fully-populated
// WalkthroughFlags, filling missing keys with WALKTHROUGH_DEFAULTS.
export const resolveWalkthroughFlags = (
  raw: Record<string, unknown> | null | undefined,
): WalkthroughFlags => {
  const out = {} as WalkthroughFlags;
  for (const key of WALKTHROUGH_KEYS) {
    const value = raw?.[key];
    out[key] = typeof value === "boolean" ? value : WALKTHROUGH_DEFAULTS[key];
  }
  return out;
};
